import React, { PropsWithChildren, PureComponent } from 'react';

import styled from 'styled-components';

import Box from '../../atoms/Box/Box';

type AccountControlGroupProps = {
  className?: string;
};

class AccountControlGroup extends PureComponent<
  PropsWithChildren<AccountControlGroupProps>
> {
  render() {
    const { className, children } = this.props;

    return <Box className={className}>{children}</Box>;
  }
}

const styledAccountControlGroup = styled(AccountControlGroup)`
  > div:last-child {
    border-bottom: 1px solid ${props => props.theme.colors.blackHaze};
  }
`;

export default styledAccountControlGroup;
